import { DeviceType, deviceTypesWithOwner } from '@ixicare/resources';

// The health thresholds are shared with the mobile app, see
// @ixicare/resources/device.health.
export {
  MAX_HOURS_NOT_SEEN,
  BEACON_MAX_DAYS_NOT_SEEN,
  LOW_BATT_THRESHOLD,
  MIN_SW_VERSION_PER_DEVICE_TYPE,
  lastSeenThresholdFor,
} from '@ixicare/resources';

export const WEARABLE_TYPES = deviceTypesWithOwner;

export const WRISTWATCH_TYPES = [DeviceType.WATCHERR, DeviceType.IXI_PRO];

export const CALLABLE_TYPES = [DeviceType.WATCHERR, DeviceType.IXI_PRO, DeviceType.EVIEW, DeviceType.TWIG];

/**
 * A legacy type and its ixi replacement: one product, one firmware, one configuration form, and
 * the same translated name. Devices of both are still in the field, so anything acting on one has
 * to act on the other.
 */
export const IXI_LITE_TYPES = [DeviceType.WRISTBAND_DISTRESS_BUTTON, DeviceType.IXI_LITE];

export const WRISTBAND_TYPES = [
  DeviceType.WRISTBAND_DISTRESS_BUTTON,
  DeviceType.IXI_LITE,
  DeviceType.IXI_TOUCH,
  DeviceType.IXI_BLACK,
];

export const WEARABLE_OR_BUTTON_TYPES = [DeviceType.WALL_MOUNTED_DISTRESS_BUTTON, ...WEARABLE_TYPES];
